window.app.factory("mime", [
  function() {
    const types = {
      "audio/aac": ["AAC audio", "AAC audio file"],
      "application/x-abiword": ["AbiWord", "AbiWord document"],
      "video/x-msvideo": ["AVI", "AVI: Audio Video Interleave"],
      "application/vnd.amazon.ebook": [
        "Kindle eBook",
        "Amazon Kindle eBook format"
      ],
      "application/octet-stream": ["Binary", "Any kind of binary data"],
      "application/x-bzip": ["BZip", "BZip archive"],
      "application/x-bzip2": ["BZip2", "BZip2 archive"],
      "application/x-csh": ["Script", "C-Shell script"],
      "text/css": ["CSS", "Cascading Style Sheets (CSS)"],
      "text/csv": ["CSV", "Comma-separated values (CSV)"],
      "application/msword": ["MS Word", "Microsoft Word"],
      "application/epub+zip": ["EPUB", "Electronic publication (EPUB)"],
      "image/gif": ["GIF", "Graphics Interchange Format (GIF)"],
      "text/html": ["HTML", "HyperText Markup Language (HTML)"],
      "text/plain": ["Plain Text", "Plain text file"],
      "image/x-icon": ["Icon", "Icon format"],
      "text/calendar": ["iCalendar", "iCalendar format"],
      "application/java-archive": ["JAR", "Java Archive (JAR)"],
      "image/jpeg": ["JPEG image", "JPEG image"],
      "application/javascript": ["JavaScript", "JavaScript (ECMAScript)"],
      "application/json": ["JSON", "JSON format"],
      "audio/midi": ["MIDI", "Musical Instrument Digital Interface (MIDI)"],
      "video/mpeg": ["MPEG Video", "MPEG Video"],
      "application/vnd.apple.installer+xml": [
        "Apple Installer",
        "Apple Installer Package"
      ],
      "application/vnd.oasis.opendocument.presentation": [
        "OpenDocument",
        "OpenDocuemnt presentation document"
      ],
      "application/vnd.oasis.opendocument.spreadsheet": [
        "OpenDocument",
        "OpenDocuemnt spreadsheet document"
      ],
      "application/vnd.oasis.opendocument.text": [
        "OpenDocument",
        "OpenDocument text document"
      ],
      "audio/ogg": ["OGG audio", "OGG audio"],
      "video/ogg": ["OGG video", "OGG video"],
      "application/ogg": ["OGG", "OGG"],
      "application/pdf": ["PDF", "Adobe Portable Document Format (PDF)"],
      "application/vnd.ms-powerpoint": [
        "MS PowerPoint",
        "Microsoft PowerPoint"
      ],
      "application/x-rar-compressed": ["RAR", "RAR archive"],
      "application/rtf": ["Text (RTF)", "Rich Text Format (RTF)"],
      "application/x-sh": ["Script", "Bourne shell script"],
      "image/svg+xml": ["SVG", "Scalable Vector Graphics (SVG)"],
      "application/x-shockwave-flash": [
        "SWF",
        "Small web format (SWF) or Adobe Flash document"
      ],
      "application/x-tar": ["TAR", "Tape Archive (TAR)"],
      "image/tiff": ["TIFF", "Tagged Image File Format (TIFF)"],
      "font/ttf": ["TT Font", "TrueType Font"],
      "application/vnd.visio": ["MS Visio", "Microsft Visio"],
      "audio/x-wav": ["WAV", "Waveform Audio Format"],
      "audio/webm": ["WEBM audio", "WEBM audio"],
      "video/webm": ["WEBM video", "WEBM video"],
      "image/webp": ["WEBP image", "WEBP image"],
      "font/woff": ["WOFF Font", "Web Open Font Format (WOFF)"],
      "font/woff2": ["WOFF Font", "Web Open Font Format (WOFF)"],
      "application/xhtml+xml": ["XHTML", "XHTML"],
      "application/vnd.ms-excel": ["MS Excel", "Microsoft Excel"],
      "application/xml": ["XML", "XML"],
      "application/vnd.mozilla.xul+xml": ["XUL", "XUL"],
      "application/zip": ["ZIP", "ZIP archive"],
      "video/3gpp": ["3GPP", "3GPP audio/video container"],
      "video/3gpp2": ["3GPP2", "3GPP2 audio/video container"],
      "application/x-7z-compressed": ["7-zip", "7-zip archive"]
    };
    return function mime(type, defaultText) {
      return types[type] || defaultText || "";
    };
  }
]);



// WEBPACK FOOTER //
// ./src/services/mimes.js